<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部车辆(' + numArr.violationCount + ')'"
        name="0"
      ></el-tab-pane>
      <el-tab-pane
        :label="'风险预警车辆(' + numArr.riskCount + ')'"
        name="2"
      ></el-tab-pane>
      <el-tab-pane
        :label="'高危预警车辆(' + numArr.highRiskCount + ')'"
        name="3"
      ></el-tab-pane>
      <el-tab-pane
        :label="'风险超时未处理车辆(' + numArr.overDueCount + ')'"
        name="4"
      ></el-tab-pane>
    </el-tabs>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <QS-search maxLine="1" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item label="车辆ID" prop="carId">
            <el-input
              v-model="params.carId"
              clearable
              placeholder="请输入车辆ID"
              v-number:integer="18"
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌号" prop="plateNo">
            <el-select
              v-model="params.plateNo"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入"
              :remote-method="
                (query) => {
                  remoteMethod(query)
                }
              "
              :loading="oLoading.fuzzy"
            >
              <el-option
                v-for="item in options"
                :key="'options' + item.id"
                :label="item.plateNo"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备案状态" prop="filingsState">
            <el-select clearable v-model="params.filingsState">
              <el-option
                v-for="item in registrationStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <!-- <el-button type="primary" size="small"> 导出数据 </el-button> -->
              <export
                :exportTemplate="exportTemplate"
                filename="车辆违章管理列表.xlsx"
                :params="getSearchParamrs()"
                v-if="judgePermission('vehicle_violation_manage_list_export')"
              ></export>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <div class="btn-box">
      <el-button
        type="primary"
        size="small"
        @click="violationManagementConfig"
        v-if="judgePermission('vehicle_violation_manage_list_config')"
      >违章管理配置</el-button>
    </div>
    <QS-common-table
      :loading="oLoading.search"
      :pagination="paginationData"
      :data="tableData"
      :columns="headData"
      @change="paginationChange"
      class="mt16"
    ></QS-common-table>
    <ViolationManagementConfig
      v-model="showDialogWrap"
      @selectBtn="selectBtn"
    />
  </div>
</template>

<script>
import ViolationManagementConfig from '../components/violationManagementConfig'
// eslint-disable-next-line import/no-cycle
import { FuzzySearch } from '@/api/domain/cars'
import { ViolationSummary, ViolationList } from '@/api/domain/carsService'
import config from '../config/violationManageList'

export default {
  components: {
    ViolationManagementConfig,
  },
  data() {
    const { headData, operateColumn, registrationStatus } = config.call(this)
    return {
      showDialogWrap: false,
      operateColumn,
      oLoading: {
        fuzzy: false,
        search: false,
      },
      exportTemplate: 'Violation',
      activeName: '0',
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      params: {
        carId: '',
        plateNo: '',
        tagType: 0,
        filingsState: '', // 备案状态
      },
      headData,
      tableData: [],
      numArr: {
        violationCount: 0,
        riskCount: 0,
        highRiskCount: 0,
        overDueCount: 0,
      },
      options: [],
      registrationStatus,
    }
  },
  created() {
    const { tabType = '0' } = this.$route.query
    this.activeName = tabType
    this.params.tagType = Number(tabType)

    this.headData.unshift(
      {
        name: 'carId',
        columnProps: {
          prop: 'carId',
          label: '车辆ID',
        },
        render: ({ row }) => {
          if (this.judgePermission('vehicle_list_detail')) {
            return (<span style="cursor: pointer;color:#0059dc" onClick={() => this.JumpCarDetail(row)}>{row.carId}</span>)
          } else {
            return (<span>{row.carId}</span>)
          }
        },
      },
    )
    // 无查看违章记录权限不展示操作列
    if (this.judgePermission('vehicle_violation_manage_list_record')) {
      this.headData.push(this.operateColumn)
    }
    this.getList()
  },
  methods: {
    // 违章管理配置
    violationManagementConfig() {
      this.showDialogWrap = true
    },
    // 获取请求参数
    getSearchParamrs() {
      const { pageSize, pageNum } = this.paginationData
      return { ...this.params, pageSize, pageNum }
    },
    /* tab切换 */
    handleClick(tab) {
      if (this.params.tagType === parseInt(tab.name)) return
      this.params.tagType = parseInt(tab.name)
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.Reset()
      // this.getList()
    },
    /* 分页切换 */
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getList()
    },
    /* 获取违章统计 */
    async getViolationSummary() {
      const { code, data } = await ViolationSummary({})
      if (code === 1) {
        if (data) {
          this.numArr = data
        }
      }
    },
    /* 获取列表 */
    async getList() {
      this.oLoading.search = true
      try {
        if (this.params.carId) {
          this.params.carId = parseInt(this.params.carId)
        }
        const { code, data } = await ViolationList({
          ...this.getSearchParamrs(),
        })
        this.oLoading.search = false
        if (code === 1) {
          this.tableData = data.items
          this.paginationData.total = data.totalNum
        }
      } catch (error) {
        this.oLoading.search = false
      }

      // 获取违章统计
      this.getViolationSummary()
    },
    /* 跳转违章记录管理 */
    // eslint-disable-next-line vue/no-unused-properties
    JumpRecord(data) {
      this.$router.push({
        path: '/vehicle/violation/record',
        query: {
          plateNo: data.plateNo,
          carId: data.carId,
        },
      })
    },
    /* 搜索 */
    selectBtn() {
      this.paginationData.pageNum = 1
      this.paginationData.pageSize = 10
      this.getList()
    },
    /* 跳转车辆详情 */
    JumpCarDetail(data) {
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: { id: data.carId },
      })
    },
    /* 车牌号模糊搜索 */
    async remoteMethod(query) {
      if (query.length >= 4) {
        this.oLoading.fuzzy = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 2,
          })
          this.oLoading.fuzzy = false
          if (code === 1) {
            this.options = data
          }
        } catch (error) {
          this.oLoading.fuzzy = false
        }
      }
    },
    /* 重置 */
    Reset() {
      this.$refs.paramsList.resetFields()
      Object.keys(this.params).forEach((item) => {
        this.params[item] = ''
      })
      this.params.tagType = parseInt(this.activeName)
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getList()
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
</style>
